import {Cureus} from '../Cureus';

Cureus.ChannelDesignWidget = {}